import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

interface Slide {
  file: string;
  title: string;
}

@Component({
  selector: 'app-jupiter',
  templateUrl: './jupiter.component.html',
  styleUrls: ['./jupiter.component.scss']
})

export class JupiterComponent implements OnInit, OnDestroy{
  slides: Slide[] = [
    { file: 'assets/images/jupiter/slides/00_hero.html', title: 'Accueil' },
    { file: 'assets/images/jupiter/slides/02_infrastructure.html', title: '1. Infrastructure' },
    { file: 'assets/images/jupiter/slides/03_ergonomie.html', title: '2. Ergonomie' },
    { file: 'assets/images/jupiter/slides/04_parametrage.html', title: '3. Paramétrage' },
    { file: 'assets/images/jupiter/slides/05_matieres.html', title: '4. Matières' },
    { file: 'assets/images/jupiter/slides/06_tiers_matieres.html', title: '5. Tiers-Matières' },
    { file: 'assets/images/jupiter/slides/07_qualite.html', title: '6. Qualité' },
    { file: 'assets/images/jupiter/slides/08_stocks.html', title: '7. Stocks' },
    { file: 'assets/images/jupiter/slides/09_couts.html', title: '8. Coûts' },
    { file: 'assets/images/jupiter/slides/10_ged.html', title: '9. GED & export' },
    { file: 'assets/images/jupiter/slides/11_portail.html', title: '10. Portail' },
    { file: 'assets/images/jupiter/slides/11_ration.html', title: '11. Ration' },
    { file: 'assets/images/jupiter/slides/12_collecte.html', title: '12. Collecte de biodéchets' },
    { file: 'assets/images/jupiter/slides/13_gmao.html', title: '13. GMAO - maintenance' },
    { file: 'assets/images/jupiter/slides/14_red.html', title: '14. Gestion de la durabilité (RED)' },
    { file: 'assets/images/jupiter/slides/15_performance.html', title: '15. Pilotage de la performance' },
    { file: 'assets/images/jupiter/slides/16_base_echange.html', title: '16. Base d\'échange' },
    { file: 'assets/images/jupiter/slides/12_conclusion.html', title: '17. Conclusion' }
  ];

  currentSlideIndex = 0;

  constructor(
      private _router: Router
  ) { }

    ngOnDestroy() {
        document.body.classList.remove('slides-page');
    }

  ngOnInit(): void {
    const organisationsBanned = ['organisation_11d8fb1b-b6c5-4155-a281-034a5b37976a', 'organisation_3323a4f3-4e41-4574-a727-19210b888290', 'organisation_202edbd1e521d29f0881224b9c000ea8', 'organisation_5c92442d-6bf7-4b35-a6a8-ae25dbc76531', 'organisation_66ca4b0f-1186-439d-83d9-7191428f890e', 'organisation_6ada83c7-9a3c-4adb-af47-fb57fa727f25'];
    const organisation = JSON.parse(sessionStorage.getItem('organisation'));
    if(organisationsBanned.includes(organisation.id)) {
      this._router.navigate(['home-board']);
    }
    document.body.classList.add('slides-page');
    this.renderMenu();
    this.loadSlideFromHash();

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === ' ') this.nextSlide();
      if (e.key === 'ArrowLeft') this.prevSlide();
    });
  }

  renderMenu() {
    const sidebar = document.getElementById('sidebar')!;
    sidebar.innerHTML = '';
    this.slides.forEach((slide, index) => {
      const item = document.createElement('div');
      item.textContent = slide.title;
      item.style.padding = '15px 25px';
      item.style.cursor = 'pointer';
      item.style.borderBottom = '1px solid #eee';
      item.style.transition = 'background 0.2s';
      item.style.color = '#333';
      item.style.background = 'white';
      item.style.fontFamily = "'Poppins', sans-serif";

      item.onmouseover = () => {
        item.style.background = '#f0f7f4';
        item.style.color = '#2d4e48'; // primary color
      };

      item.onmouseout = () => {
        if (index === this.currentSlideIndex) {
          item.style.background = '#2d4e48';
          item.style.color = 'white';
        } else {
          item.style.background = 'white';
          item.style.color = '#333';
        }
      };

      item.onclick = () => {
        this.loadSlide(index);
        this.toggleSidebar();

        // Update styles manually for active item
        Array.from(sidebar.children).forEach((child, i) => {
          const el = child as HTMLElement;
          if (i === index) {
            el.style.background = '#2d4e48';
            el.style.color = 'white';
          } else {
            el.style.background = 'white';
            el.style.color = '#333';
          }
        });
      };

      sidebar.appendChild(item);
    });
  }

  loadSlide(index: number) {
    if (index < 0 || index >= this.slides.length) return;

    this.currentSlideIndex = index;
    const frame = document.getElementById('slideFrame') as HTMLIFrameElement;

    window.location.hash = this.slides[index].file;

    frame.classList.add('fade-out');

    setTimeout(() => {
      frame.src = this.slides[index].file;
      frame.onload = () => {
        frame.classList.remove('fade-out');
      };
      this.updateUI();
    }, 200);
  }

  updateUI() {
    const progress = ((this.currentSlideIndex + 1) / this.slides.length) * 100;
    (document.getElementById('progressBar') as HTMLElement).style.width = `${progress}%`;

    (document.getElementById('slideCounter') as HTMLElement).textContent = `${this.currentSlideIndex + 1} / ${this.slides.length}`;

    document.querySelectorAll('.menu-item').forEach((item, index) => {
      item.classList.toggle('active', index === this.currentSlideIndex);
    });
  }

  nextSlide() {
    if (this.currentSlideIndex < this.slides.length - 1) {
      this.loadSlide(this.currentSlideIndex + 1);
      this.updateSidebarStyles();
    }
  }

  prevSlide() {
    if (this.currentSlideIndex > 0) {
      this.loadSlide(this.currentSlideIndex - 1);
      this.updateSidebarStyles();
    }
  }


  updateSidebarStyles() {
    const sidebar = document.getElementById('sidebar')!;
    Array.from(sidebar.children).forEach((child, i) => {
      const el = child as HTMLElement;

      if (i === this.currentSlideIndex) {
        // Active slide
        el.style.background = '#2d4e48'; // dark background
        el.style.color = 'white';         // text color
      } else {
        // Inactive slides
        el.style.background = 'white';
        el.style.color = '#333';
      }
    });
  }

  toggleSidebar() {
    const sidebar = document.getElementById('sidebar')!;
    const container = document.querySelector('.slide-container')!;
    const toggleBtn = document.getElementById('menuToggleBtn')!;

    sidebar.classList.toggle('open');
    container.classList.toggle('full-width');

    if (sidebar.classList.contains('open')) toggleBtn.classList.add('visible');
    else toggleBtn.classList.remove('visible');
  }

  loadSlideFromHash() {
    const hash = window.location.hash;
    if (hash) {
      const slideFile = hash.substring(1);
      const foundIndex = this.slides.findIndex(s => s.file === slideFile);
      if (foundIndex !== -1) {
        this.loadSlide(foundIndex);
        return;
      }
    }
    this.loadSlide(0);
  }
}
